import {
    AfterViewInit, ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    TemplateRef,
    ViewChild,
    ViewContainerRef
} from '@angular/core';

import { faAngleUp, faAngleDown, IconDefinition } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'th-text',
    template: `
        <ng-template #template>
            <th mat-header-cell
                #cell
                class="text-header {{colPosition}}"
                [class.can-click]="collapser"
                [class.emphasis]="emphasis"
                [class.strong]="strong"
                [class.is-important]="isImportant"
                [class.is-hidden]="isHidden"
                [class.center]="isCenter"
                [class.left-th]="isLeft"
                [class.is-top]="isTop"
                [class.white]="isWhite"
                [class.small-height]="isSmallHeight"
                [attr.colspan]="colspan"
                (click)="collapse()"
                [style.left]="left"
                [style.width]="width"
                [style.minWidth]="width"
                [style.maxWidth]="width">
                <div class="container-th"
                     [class.has-collapser]="collapser"
                     [class.no-wrap]="noWrap">
                    <ng-content></ng-content>
                    <div class="arrow-container" *ngIf="collapser">
                        <fa-icon [icon]="isVisible ? iconAngleUp : iconAngleDown"></fa-icon>
                    </div>
                </div>
            </th>
        </ng-template>`,
    styleUrls: ['./th-text.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,

})

export class ThTextComponent implements OnInit, OnChanges, AfterViewInit {
    @Input()
    public emphasis: boolean;
    @Input()
    public strong: boolean;
    @Input()
    public isSticky: boolean;
    @Input()
    public leftPosition: number;
    @Input()
    public text: string;
    @Input()
    public colspan: number = 1;
    @Input()
    public colIndex: number;
    @Input()
    public collapser: boolean;
    @Input()
    public isVisible: boolean = true;
    @Input()
    public canEmitRightPosition: boolean;
    @Input()
    public isImportant: boolean;
    @Input()
    public isWhite: boolean;
    @Input()
    public isCenter: boolean;
    @Input()
    public isLeft: boolean;
    @Input()
    public isTop: boolean;
    @Input()
    public width: string;
    @Input()
    public noWrap: boolean;
    @Input()
    public isSmallHeight: boolean;
    @Input()
    public isHidden: boolean;

    @Input()
    get isCollapsed(): boolean {
        return this.isCollapsedValue;
    }

    set isCollapsed(state: boolean) {
        this.isCollapsedValue = state;
        this.isVisible = state;
        this.isCollapsedChange.emit(this.isCollapsedValue);
    }

    @Output()
    public readonly onCollapse: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output()
    public readonly isCollapsedChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output()
    public readonly onEmitRightPosition: EventEmitter<number> = new EventEmitter<number>();

    public colPosition: string;
    public left: string;

    @ViewChild('template', { read: TemplateRef, static: true }) public template: TemplateRef<ElementRef>;

    @ViewChild('cell') public cell: ElementRef;

    private isCollapsedValue: boolean;

    public iconAngleDown: IconDefinition = faAngleDown;

    public iconAngleUp: IconDefinition = faAngleUp;

    constructor(
        private readonly viewContainerRef: ViewContainerRef,
    ) {
    }

    public ngOnInit(): void {
        this.viewContainerRef.createEmbeddedView(this.template);
        setTimeout((): void => this.stickCell());
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.colIndex && (changes.colIndex.currentValue || changes.colIndex.currentValue === 0)) {
            this.colPosition = `col-${changes.colIndex.currentValue}`;
        }

        if (this.leftPosition && changes && changes.leftPosition && changes.leftPosition.currentValue) {
            this.left = `${changes.leftPosition.currentValue }px`;
        }
    }

    public ngAfterViewInit(): void {

    }

    public collapse(): void {
        if (this.collapser) {
            this.isVisible = !this.isVisible;
            this.isCollapsed = !this.isCollapsed;
            this.onCollapse.emit(this.isVisible);
        }
    }


    private stickCell(): void {
        //dynamic sticky, this way we don't need any extra css
        if (this.isSticky) {
            const left: number = this.cell.nativeElement.offsetLeft - this.cell.nativeElement.parentElement.offsetParent.offsetLeft;
            this.cell.nativeElement.style.zIndex = "1";
            this.cell.nativeElement.style.left = `${left}px`;
            this.cell.nativeElement.style.position = "sticky";
        }
        //avoid width change when collapse on chapter blocks
        if (this.colPosition === 'col-0') {
            const width: number = this.cell.nativeElement.offsetWidth;
            this.cell.nativeElement.style.minWidth = `${width}px`;
        }
        if (this.canEmitRightPosition) {
            const left: number = this.cell.nativeElement.offsetLeft - this.cell.nativeElement.parentElement.offsetParent.offsetLeft;
            this.onEmitRightPosition.emit(left + this.cell.nativeElement.offsetWidth);
        }
    }
}
